import styles from './Loader.module.css';
import React from 'react';

function Loader(){
    return <React.Fragment >
        <div className={styles.contain}>
            <div>
            <div><img className={styles.logo} src="/boswordsLogo.avif" alt="Boswords Logo"></img></div>
            <div className={styles.loadText} style={{textAlign: 'center'}}>Loading. . .</div>

            </div>
        </div>
    </React.Fragment>
}

export default Loader;